<template>
    <div id="search-wacana">
        <div>
            <blockquote v-if="wacana.id != 0">
                <p v-html="previewWacana"></p>
            </blockquote>
        </div>

        <div>
            <v-btn outlined text @click="showCreateWacanaModal = true"
                >Buat Baru</v-btn
            >
            <v-btn outlined text class="mr-2" @click="showModal = true"
                >Pilih</v-btn
            >
            <v-btn
                color="touchBlue"
                class="blew--text"
                elevation="0"
                v-if="wacana.id != 0"
                @click="editWacana"
                >Edit</v-btn
            >
            <v-btn
                color="touchRed"
                class="redLight--text"
                elevation="0"
                v-if="wacana.id != 0"
                @click="showConfirmation = true"
                >Hapus</v-btn
            >
        </div>

        <v-dialog
            v-model="showModal"
            transition="dialog-top-transition"
            width="940px"
            min-height="537px"
            max-height="771px"
            @click:outside="showModal = false"
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title
                        class="d-flex align-center justify-space-between"
                    >
                        <span>Cari Wacana</span>

                        <!-- Search bar (debounced) -->
                        <div
                            class="d-flex align-center mt-2"
                            style="width: 100%"
                        >
                            <div class="mt-3 px-1" style="width: 100%">
                                <v-text-field
                                    v-model="searchValue"
                                    placeholder="Cari isi wacana"
                                    append-icon="mdi-magnify"
                                    hide-details
                                    outlined
                                    clearable
                                    class="mx-4"
                                    style="width: calc(100% - 32px)"
                                    @keyup.enter="loadData"
                                ></v-text-field>
                            </div>

                            <v-progress-circular
                                v-if="isLoading"
                                indeterminate
                                size="22"
                                class="ml-2"
                            ></v-progress-circular>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <app-datatable
                            :hideSearch="true"
                            :items="wacanas"
                            :headers="headers"
                            :hasAction="true"
                            :custom-pagination-current-page="1"
                            :custom-pagination-per-page="10"
                            :hideTop="true"
                            @dblClicked="
                                wacana = { id: $event.id, content: $event.isi };
                                showModal = false;
                            "
                        ></app-datatable>
                    </v-card-text>

                    <v-card-actions class="justify-end">
                        <v-btn text @click="dialog.value = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <app-modal v-if="showConfirmation" @ok="resetWacana">
            <h4 slot="header">Perhatian</h4>
            <div slot="body">
                <p>Apakah anda yakin ingin melepas wacana ini dari soal?</p>
            </div>
        </app-modal>

        <v-dialog
            v-model="showCreateWacanaModal"
            transition="dialog-top-transition"
            width="675px"
            min-height="537px"
            max-height="771px"
            @click:outside="showCreateWacanaModal = false"
            scrollable
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-title>Buat Wacana Baru</v-card-title>
                    <v-divider />
                    <v-card-text class="pa-0" width="100%">
                        <app-editor
                            :value="wacana.content"
                            :hasUpload="true"
                            title="Wacana"
                            @content-updated="wacana.content = $event"
                        ></app-editor>
                    </v-card-text>
                    <v-divider />
                    <v-card-actions class="justify-end">
                        <v-btn text elevation="0" @click="dialog.value = false"
                            >Batal</v-btn
                        >
                        <v-btn dark color="blew" @click="saveWacana()"
                            >Simpan</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>
    </div>
</template>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import itembankService from "@/modules/itembank/services/itembank.js";
import Marked from "marked";
import MarkdownEditor from "@/modules/global/components/plugins/MarkdownEditor-c";
import Modal from "@/modules/global/components/plugins/Modal";
import Moment from "moment";
import debounce from "lodash.debounce";

export default {
    name: "wacana",

    components: {
        "app-datatable": DataTable,
        "app-editor": MarkdownEditor,
        "app-modal": Modal,
    },

    props: {
        value: Object,
        mapel: [String, Number],
    },

    data() {
        return {
            showModal: false,
            showConfirmation: false,
            showCreateWacanaModal: false,
            isLoading: false,
            headers: [
                { text: "No", value: "no", width: "150px" },
                { text: "Konten", value: "isi" },
                { text: "Created At", value: "createdAt", width: "150px" },
                { text: "Aksi", value: "actions", width: "150px" },
            ],
            wacanas: [],
            wacana: { id: 0, content: "" },
            searchValue: "",
            doSearchDebounced: null,
        };
    },

    computed: {
        previewWacana() {
            return Marked(this.wacana.content);
        },
    },

    methods: {
        resetWacana() {
            this.wacana = { id: 0, content: "" };
            this.showConfirmation = false;
        },

        saveWacana() {
            this.showCreateWacanaModal = false;
            const postData = {
                mapelId: this.mapel,
                wacana: this.wacana.content,
            };

            if (this.wacana.id == 0) {
                itembankService.createWacana(postData, (result) => {
                    if (result.success) {
                        this.wacana = {
                            id: result.data.id,
                            content: result.data.isi,
                        };
                        this.loadDataForMapel(this.mapel);
                    }
                });
            } else {
                itembankService.updateWacana(
                    this.wacana.id,
                    postData,
                    (result) => {
                        if (result.success) this.loadDataForMapel(this.mapel);
                    }
                );
            }
        },

        editWacana() {
            this.showCreateWacanaModal = true;
        },

        loadData() {
            if (!this.mapel) return;
            this.isLoading = true;

            itembankService.getListWacana(
                this.mapel,
                this.searchValue,
                (result) => {
                    if (result.success) {
                        this.wacanas = result.data.map((wacana, index) => ({
                            no: index + 1,
                            id: wacana.id,
                            isi: wacana.isi,
                            createdAt: Moment(wacana.created_at).fromNow(),
                        }));
                    }
                    this.isLoading = false;
                }
            );
        },

        loadDataForMapel(mapelId) {
            this.searchValue = "";
            this.wacana = { id: 0, content: "" };
            this.wacanas = [];
            if (!mapelId) return;

            itembankService.getListWacana(mapelId, "", (result) => {
                if (result.success) {
                    this.wacanas = result.data.map((wacana, index) => ({
                        no: index + 1,
                        id: wacana.id,
                        isi: wacana.isi,
                        createdAt: Moment(wacana.created_at).fromNow(),
                    }));
                }
            });
        },
    },

    watch: {
        wacana(val) {
            this.$emit("selected", val);
        },
        value(val) {
            this.wacana = val;
        },
        searchValue() {
            this.doSearchDebounced();
        },
        mapel(newVal) {
            if (newVal) this.loadData();
        },
    },

    mounted() {
        // Proper debounce setup
        this.doSearchDebounced = debounce(() => this.loadData(), 500);
        this.loadData();
    },
};
</script>

<style scoped>
#search-wacana blockquote {
    border-left: 4px solid #e0e0e0;
    margin-left: 0;
    padding-left: 12px;
}
</style>



// WEBPACK FOOTER //
// Wacana.vue?53672f2e